import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { CouponDepositForm } from './CouponDepositForm';

interface CouponDepositBond {
  id: string;
  isin: string;
  issue_number: string;
  coupon_rate: number;
  face_value: number;
  currency: string;
}

interface CouponDepositDialogProps {
  bond: CouponDepositBond;
  couponDate: string;
  couponAmount: number | null;
  trigger: React.ReactNode;
}

export function CouponDepositDialog({ bond, couponDate, couponAmount, trigger }: CouponDepositDialogProps) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Deposit Coupon Payment</DialogTitle>
        </DialogHeader>
        <CouponDepositForm
          bond={bond}
          couponDate={couponDate}
          couponAmount={couponAmount}
          onSuccess={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
